import { styled } from '@mui/material/styles';
export const Credits = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    a: {
        display: 'flex',
        alignItems: 'flex-end',
    },
    '.institute-logo:not(:first-child)': {
        marginLeft: theme.spacing(2.5),
    },
    img: {
        maxHeight: theme.spacing(8.5),
    },
    [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        marginTop: theme.spacing(3.5),
    },
}));
//# sourceMappingURL=styles.js.map